import { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalBody, ModalHeader, ModalTitle } from 'components/modal'
import { track, tracking, withContextualizedTracking } from 'lib/analytics'
import {
  SHOW_AUTH_MODAL_EVENT,
  AUTH_CONTEXT_REVIEW,
  AUTH_CONTEXT_QUESTION,
} from './constants'
import {
  LoginFormContainer as LoginForm,
  redirect as loginRedirect,
} from './login-form'
import { setCurrentUser } from './utils/setCurrentUser/setCurrentUser'

class AuthModal extends Component {
  static propTypes = {
    show: PropTypes.bool,
    recaptcha: PropTypes.bool,
  }

  state = {
    show: false,
    onAuthSuccess: ({ user, redirectUrl }) => {
      loginRedirect(redirectUrl)
      this.setState({ show: false })
    },
    authContext: null,
  }

  componentDidMount() {
    this.setState({ show: this.props.show })
    PubSub.subscribe(SHOW_AUTH_MODAL_EVENT, this.handleShowAuthModal)
  }

  componentWillUnmount() {
    PubSub.unsubscribe(SHOW_AUTH_MODAL_EVENT, this.handleShowAuthModal)
  }

  handleAuthSuccess = ({ user, redirectUrl }) => {
    this.state.onAuthSuccess({ user, redirectUrl })
  }

  handleHide = () => {
    this.setState({ show: false })
  }

  @tracking(() => ({
    event: track.logInStarted({
      eventLocation: track.EventLocation.LOG_IN_MINUS_LOG_IN_MODAL,
      userAuthenticationMethod: track.UserAuthenticationMethod.EMAIL,
    }),
  }))
  handleShowAuthModal = (callback, authContext) => {
    const onAuthSuccess = ({ user, redirectUrl }) => {
      setCurrentUser(user)
      this.setState({ show: false }, () => {
        callback ? callback(user) : loginRedirect(redirectUrl)
      })
    }
    this.setState({
      show: true,
      onAuthSuccess,
      authContext,
    })
  }

  render() {
    let title
    let loginFormOptions
    const authContext = this.state.authContext
    switch (authContext) {
      case AUTH_CONTEXT_REVIEW:
      case AUTH_CONTEXT_QUESTION:
        title = {
          AUTH_CONTEXT_REVIEW: 'Log In To Submit Your Review',
          AUTH_CONTEXT_QUESTION: 'Log In To Ask Your Question',
        }[authContext]
        let fallbackDescription = {
          AUTH_CONTEXT_REVIEW:
            'You must have a Babylist account to submit a review.',
          AUTH_CONTEXT_QUESTION:
            'You must have a Babylist account to ask a question.',
        }[authContext]
        const fallback = <p className="text-right">{fallbackDescription}</p>
        loginFormOptions = { fallback }
        break
      default: // use default -> signup link
        title = 'Log In To Your Registry'
        loginFormOptions = null
        break
    }

    return (
      <Modal show={this.state.show} onHide={this.handleHide}>
        <ModalHeader
          closeButton
          onHide={this.handleHide}
          className="with-title"
        >
          <ModalTitle className="text-center">{title}</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <LoginForm
            onAuthSuccess={this.handleAuthSuccess}
            recaptcha={this.props.recaptcha}
            {...loginFormOptions}
          />
        </ModalBody>
      </Modal>
    )
  }
}

const AuthModalWithTracking = withContextualizedTracking()(AuthModal)

export default AuthModalWithTracking
